import { getRequest, postRequest } from "../utils/axois";
import Vue from 'vue'

/**
 * 账号密码登录 eg：测试案例 zmf
 */
//export const accountLogin = (username, password) => fetch('scp20/rest/app/login', {username, password}, 'POST');
export const accountLogin = (username, password) => postRequest('scp20/rest/app/login', { username, password });

/**
 * 线上活动详情
 * @param {*} coursewareBaseId
 * @param {*} classId
 * @param {*} taskId
 */
export const getActivityDetail = (coursewareBaseId, classId, taskId) => postRequest(Vue.prototype.stuApiUrl + '/task/getCoursewareBaseInfo', {
  coursewareBaseId: coursewareBaseId,
  classId: classId,
  taskId: taskId
})

/**
 * 线上活动子项详情
 * @param {*} subId
 * @param {*} classId
 */
export const getSubActivityDetail = (subId, classId) => postRequest(Vue.prototype.stuApiUrl + '/task/getTaskBase', {
  taskBaseId: subId,
  classId: classId
})

/**
 * 获取课堂活动的附件资源
 * @param {*} coursewareBaseId
 * @param {*} classId
 */
export const getCoursewareFiles = (coursewareBaseId, classId) => postRequest(Vue.prototype.stuApiUrl + '/task/getCoursewareFiles', {
  coursewareBaseId: coursewareBaseId,
  classId: classId
})

/**
 * 设置作业为已读状态，必须调用（在进入作业之前）
 * @param {*} taskId 
 * @param {*} groupId 
 * @param {*} fileId 
 */
export const taskRead = (taskId, groupId, fileId) => postRequest(Vue.prototype.stuApiUrl + '/task-report/read', {
  taskId: taskId,
  groupId: groupId,
  fileId: fileId
})

/**
 * 退出小组任务时必须调用此接口，否则其它小组成员无法进入修改
 * @param {*} taskId 
 * @param {*} groupId 
 */
export const taskClean = (taskId, groupId) => postRequest(Vue.prototype.stuApiUrl + '/task/clean', {
  taskId: taskId,
  groupId: groupId
})

/**
 * 小组作业前置校验，确保只有一个小组成员在修改作业
 * @param {*} taskId 
 * @param {*} groupId 
 */
export const checkTask = (taskId, groupId) => postRequest(Vue.prototype.stuApiUrl + '/task/check', {
  taskId: taskId,
  groupId: groupId
})

/**
 * 获取作业内容接口
 * @param {*} taskId
 */
export const getTask = (taskId) => postRequest(Vue.prototype.stuApiUrl + '/task/get', {
  taskId: taskId
})

/**
 * 作业保存/提交 接口
 * @param {*} taskId
 * @param {*} type  0:保存 1：提交
 * @param {*} reports
 * @param {*} fileReports
 * @param {*} answer
 */
export const commitTask = (taskId, groupId, studentId, type, reports, fileReports, answer) => postRequest(Vue.prototype.stuApiUrl + '/task-report/save', {
  taskId: taskId,
  groupId: groupId,
  studentId: studentId,
  type: type,
  reports: reports,
  fileReports: fileReports,
  answer: answer
})

/**
 * 获取四位随机数
 * @param {*} taskId
 */
export const getTaskCode = (taskId) => postRequest(Vue.prototype.stuApiUrl + '/task-report/createTaskCode', {
  taskId: taskId
})

/**
 * 确认pc提交完成
 * @param {*} taskId
 * @param {*} groupId
 * @param {*} token
 */
export const uploadCompleteByPC = (taskId, groupId, token) => postRequest(Vue.prototype.stuApiUrl + '/task/quit-channel', {
  taskId: taskId,
  groupId: groupId,
  token: token
})

/**
 * 获取小组成员信息
 * @param {*} groupId 
 */
export const getGroupInfo = (groupId) => postRequest(Vue.prototype.stuApiUrl + '/courseware-group-info/data', {
  groupId: groupId
})

/**
 * 测验提交
 * @param {*} type 0:保存 1：提交
 * @param {*} taskId 
 * @param {*} taskBaseId 
 * @param {*} reports 
 */
export const commitTest = (type, taskId, taskBaseId, reports) => postRequest(Vue.prototype.stuApiUrl + '/task-report/saveTesting', {
  type: type,
  taskId: taskId,
  taskBaseId: taskBaseId,
  reports: reports
})

/**
 * 开始限时测验答题
 * @param {*} taskId 
 */
export const startAnswer = (taskId) => postRequest(Vue.prototype.stuApiUrl + '/task/answeringTime', {
  taskId: taskId
})

/**
 * 统计资源点击次数
 * @param fileId
 * @param classId
 * @returns {AxiosPromise<any>}
 */
export const inspectResTimes = (context, fileId, classId) => postRequest(context.stuApiUrl + "/courseware/file/read", { fileId: fileId, classId: classId });

/**
 * 统计资源时长
 * @param fileId
 * @param classId
 * @param viewTime
 * @returns {AxiosPromise<any>}
 */
export const inspectResDulTime = (context, fileId, classId, viewTime) => postRequest(context.stuApiUrl + "/courseware/file/view", { fileId: fileId, classId: classId, viewTime: viewTime });


///////////////////////////////////////////////////////////////课堂报告////////////////////////////////////////////////////////////////////
/**
 *
 * @param context
 * @param courseId
 * @param classId
 * @returns {AxiosPromise<any>}
 */
export const getClassReportType = (context, courseId, classId) => postRequest(context.stuApiUrl + '/course/get-filter-type', { courseId: courseId, classId: classId });

/**
 *
 * @param context
 * @param courseId
 * @param classId
 * @param searchKey
 * @param filterType
 * @returns {AxiosPromise<any>}
 */
export const getClassReportCourse = (context, courseId, classId, searchKey, filterType) => postRequest(context.stuApiUrl + '/course/courseDetail',
  { courseId: courseId, classId: classId, searchKey: searchKey, filterType: filterType });


export const getClassReportDetailInfo = function (context, isReport, coursewareBaseId, coursewareId) {

  var url = context.stuApiUrl + '/courseware/base';
  var params = { coursewareBaseId: coursewareBaseId };
  if (isReport) {
    url = context.stuApiUrl + '/courseware/detail';
    params = { coursewareId: coursewareId };
  }

  return postRequest(url, params);
}

/**
 *
 * @param context
 * @param coursewareBaseId
 * @param classId
 * @returns {AxiosPromise<any>}
 */
export const getClassReportTaskList = (context, coursewareBaseId, classId) => postRequest(context.stuApiUrl + "/task/list", { coursewareBaseId: coursewareBaseId, classId: classId });

/**
 *
 * @param classId
 * @returns {AxiosPromise<any>}
 */
export const getClassReportGroup = (context, classId, coursewareId) => postRequest(context.stuApiUrl + "/course/user/groups", { classId: classId, coursewareId: coursewareId})

/***
 *
 * @param context
 * @param courseId
 * @param coursewareBaseId
 * @param classId
 * @param coursewareId
 * @returns {AxiosPromise<any>}
 */
export const getClassReportResList = (context, courseId, coursewareBaseId, classId, coursewareId) => postRequest(context.stuApiUrl + "/courseware/resource/teacher", {
  courseId: courseId, coursewareBaseId: coursewareBaseId,
  classId: classId, coursewareId: coursewareId
});


/**
 *
 * @param context
 * @param coursewareId
 * @param classId
 * @returns {AxiosPromise<any>}
 */
export const getClassReportClassQues = (context, coursewareId, classId) => postRequest(context.stuApiUrl + "/courseware/user/data", { coursewareId: coursewareId, classId: classId });


/**
 *
 * @param context
 * @param coursewareId
 * @returns {AxiosPromise<any>}
 */
export const getClassReportClassDisc = (context, coursewareId) => postRequest(context.stuApiUrl + "/courseware-disc/query-disc-list", { coursewareId: coursewareId });//, status : 40)

/***
 * @param context
 * @param coursewareId
 * @returns {AxiosPromise<any>}
 */
export const getClassResportAnserRes = (context, coursewareId) => postRequest(context.stuApiUrl + "/courseware/question/query-report-situations", { coursewareId: coursewareId });//, status : 40)

/**
 * 判断是否为云端版本
 */
export const checkCloudServerVersion = () => getRequest(Vue.prototype.stuApiUrl + '/student/cloudServer')

/**
 * 获取课上的快速讨论的截图和附件信息
 * @param {*} parentId 
 * @param {*} coursewareId 
 */
export const getFastDiscussFileInfo = (parentId, coursewareId) => postRequest(Vue.prototype.stuApiUrl + '/courseware/file/getCoursewaredDiscFile', {
  parentId: parentId,
  coursewareId: coursewareId,
  type: 28
})

/**
 * 获取成绩单信息
 * @param {*} courseId 
 * @param {*} classId 
 */
export const getReportCardInfo = (courseId, classId) => postRequest(Vue.prototype.stuApiUrl + '/scoreReport/getStatistics', {
  courseId: courseId,
  classId: classId
})

/**
 * 获取考勤数据
 * @param {*} courseId 
 * @param {*} classId 
 */
export const getAttendanceInfo = (courseId, classId) => postRequest(Vue.prototype.stuApiUrl + '/scoreReport/getAttendance', {
  courseId: courseId,
  classId: classId
})

/**
 * 获取线上活动成绩
 * @param {*} courseId 
 * @param {*} classId 
 */
export const getOnlineInfo = (courseId, classId) => postRequest(Vue.prototype.stuApiUrl + '/scoreReport/getOnline', {
  courseId: courseId,
  classId: classId
})

/**
 * 获取课堂活动成绩
 * @param {*} courseId 
 * @param {*} classId 
 */
export const getCoursewareInfo = (courseId, classId) => postRequest(Vue.prototype.stuApiUrl + '/scoreReport/getCourseware', {
  courseId: courseId,
  classId: classId
})

/**
 * 查看任务接口，用于给任务设置已读状态
 * @param {*} taskId 
 */
export const viewTask = (taskId) => postRequest(Vue.prototype.stuApiUrl + '/task/viewTime', {
  taskId: taskId
})

/**
 * 获取学生课程状态
 * @returns {AxiosPromise<any>}
 */
export const getStudentCoursewareStateNew = () => postRequest(Vue.prototype.stuApiUrl + '/course/user/curr-courseware-status',{})

/**
 * loop 更新查看状态数据接口
 * @returns {AxiosPromise<any>}
 */
export const getStudentCoursewareState = () => postRequest(Vue.prototype.stuApiUrl + '/course/status',{})



// WEBPACK FOOTER //
// ./src/service/getData.js